module.exports = {
  attach: function() {
    const $cart = $('#gtm-cart-products');

    if ($cart.is('*')) {
        const products = $cart.attr('data-gtm-products');
        const details = $cart.attr('data-gtm-cartdetails');
        const data = { products, details } ;
        $('body').trigger('gtm:eec:viewCart', data);
        $('body').trigger('gtm:ga4:viewCart', data);
    }
  }
}